<template>
  <div v-loading.body.lock="loading" element-loading-text="加载中..." class="app-container">
    <product-detail ref="productDetail" :store-id="storeId" :product-id="goodsId" can-edit :is-create="action === 'create'" @create="changeCreate" />

    <div class="app-form-button-group">
      <el-button icon="el-icon-back" @click="onBack">返回列表</el-button>
      <el-button type="info" @click="onCreate">新增商品</el-button>
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
    </div>
  </div>
</template>

<script>
import ProductDetail from './review'

export default {
  name: 'StoreGoodsDetail',
  components: { ProductDetail },
  data() {
    return {
      loading: false,
      action: 'create',
      storeId: '',
      goodsId: '',
      from: ''
    }
  },
  created() {
    this.goodsId = this.$route.query.id || ''
    this.storeId = this.$route.query.storeId || ''
    this.action = this.$route.query.action || 'create'
    this.from = this.$route.query.from || ''
  },
  methods: {
    onBack() {
      if (this.from === 'store') {
        this.$store.dispatch('tagsView/delView', this.$route)
        this.$router.push({ path: `/store/goods/index`, query: { storeId: this.storeId }})
      } else {
        this.$router.go(-1)
      }
    },
    onCreate() {
      this.$refs.productDetail.onCreateNew()
    },
    changeCreate() {
      this.goodsId = ''
      this.action = 'create'
    },
    onSubmit() {
      this.loading = true
      this.$refs.productDetail.onSave().then(() => {
        this.$util.delay(500).then(() => {
          this.loading = false
          this.$confirm('商家商品数据保存成功，是否继续添加？', '温馨提示', {
            confirmButtonText: '继续添加',
            cancelButtonText: '返回列表',
            type: 'success'
          }).then(() => this.onCreate()).catch(() => this.onBack())
        })
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding-bottom: 50px;
}
.mobile .inline-form-item ::v-deep {
  .el-form-item__label {
    width: 85px;
  }
  .max-width {
    max-width: 100%;
  }
}
</style>
